import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	description: {
		defaultMessage: 'Drag a gadget to this column or ',
		id: 'dashboard-edit.placeholder.description',
		description: 'Describes the capable action of this placeholder.',
	},
});
